(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('[data-tabs]').each(function () {
		// Find tab links and content
		var tabs = $(this);
		var links = tabs.find('a[href^="#"]');
		var contentIds = [];

		links.each(function () {
			contentIds.push($(this).attr('href'));
		});

		var content = $(contentIds.join(','));

		// Sets the active tab
		var setActiveTab = function (href, dontUpdateHash) {
			links.removeClass('active').filter(function () {
				return $(this).attr('href') == href;
			}).addClass('active');

			content.removeClass('active').filter(function () {
				return $(this).attr('id') == href.substr(1);
			}).addClass('active');

			if (!dontUpdateHash && 'replaceState' in window.history) {
				window.history.replaceState('', document.title, window.location.pathname + window.location.search + href);
			}
		};

		// Is a tab set in URL?
		if (window.location.hash && contentIds.indexOf(window.location.hash) !== -1) {
			setActiveTab(window.location.hash, true);
		}
		else {
			setActiveTab(links.eq(0).attr('href'), true);
		}

		links.on('click', function (e) {
			e.preventDefault();

			setActiveTab($(this).attr('href'));
		});
	});
})();
